// import management from './management';
const giveUp = () => import('./giveUp');
const management = () => import('./management');
const manageHistory = () => import('./manageHistory');

const internationalWaters = [
  {
    path: '/internationalWaters/giveUp', name: 'giveUp', component: giveUp, meta: { c: 'internationalWaters', a: 'giveUp' }
  },
  {
    path: '/internationalWaters/management', name: 'internationalWatersManagement', component: management, meta: { c: 'internationalWaters', a: 'management' }
  },
  {
    path: '/internationalWaters/manageHistory', name: 'internationalWatersManageHistory', component: manageHistory, meta: { c: 'internationalWaters', a: 'management' }
  },
];

export default internationalWaters;
